import { createRemoteComponent } from "@module-federation/bridge-react";
import { loadRemote, registerRemotes } from "@module-federation/enhanced/runtime";
import { getRemote, Remote, RemoteEnvironment, RemoteRegion } from "@teamworksdev/web-sdk/module-federation";
import { ComponentType, CSSProperties } from "react";
import { RemoteAppContainerError } from "../../../../../components/AppError/HubAppError";
import { environment } from "apps/web/src/environment";

const loadMessaging = async ({ force }: { force?: boolean } = {}) => {
  const mfeEnvironment = environment.VITE_TW_MFE_ENV as RemoteEnvironment;
  const region = environment.VITE_REGION as RemoteRegion;
  if (!mfeEnvironment) throw new Error("VITE_TW_MFE_ENV environment variable is not set");
  if (!region) throw new Error("VITE_REGION environment variable is not set");

  registerRemotes([getRemote(mfeEnvironment, region, "messaging") as Remote], {
    force,
  });

  return loadRemote("messaging/export-app");
};

type UnityMessagingMFEProps = {
  basename: string;
};

const MessagingMFE = createRemoteComponent({
  fallback: ({ error }) => (
    <RemoteAppContainerError
      refresh={() => loadMessaging({ force: true }).then(() => error)}
      failureHeader="Error: Page load failure"
      failureDescription="We had some trouble loading Messaging. Please refresh the page or get in touch at support@teamworks.com if the problem persists."
    />
  ),
  loader: () => loadMessaging(),
  loading: null,
}) as unknown as ComponentType<UnityMessagingMFEProps & { style?: CSSProperties }>;

export const UnityMessagingMFE: ComponentType<UnityMessagingMFEProps> = props => {
  return (
    <MessagingMFE
      {...props}
      style={{ height: "100%", display: "flex", flexDirection: "column" }}
    />
  );
};
